__webpack_require__.p = "https://www.gla.ac.uk/t4/uofglife/production/";